<template>
  <BaseLayout>
    <div>
      <h5><font-awesome-icon icon="user-lock" class="icon"/> Meu Perfil</h5>
        <br>
        <SharedProfile v-if="loaded" :profile="profile" :disableInput="disableInput" @save="saveProfile" @back="backProfile" @revokeAll="revokeAll"></SharedProfile>
    </div>
  </BaseLayout>
</template>
<style></style>
<script>
  /* eslint-disable */
import BaseLayout from '@/components/BaseLayout';
import SharedProfile from '@/components/shared-profile/SharedProfile';
import { mapActions,mapState } from 'vuex';

export default{
  data(){
    return {
      loaded: false,
      disableInput: false,
    }
  },
  components: {        
    BaseLayout,
    SharedProfile
  },
  async mounted(){
    var instance = this;
    let result = await this.ActionProfileGetData();
    if(result == null){
      instance.ActionSignOut();
      instance.$toast.success("Sua conta foi excluida", {
                timeout: 10000
      });      
      this.$router.push({ name: 'revoked' });            
    } else {
      this.loaded = true
    }
  },
  methods:{
    saveProfile: function(formData){
      this.ActionProfileSetData(formData)
    },
    backProfile: function(){
      this.$router.push({name: 'access-locations'});
    },
    revokeAll: function(){

       var instance = this;

      let message = {
          title: 'Revogar dados de acesso',
          body: 'Quando você utiliza o WISPOT para conectar-se a uma rede WIFI você concede o acesso aos seguintes dados: foto, nome e sobrenome, genero, data de nascimento, documento, telefone e localidade.<br><br>Você pode revogar o acesso a esses dados a qualquer momento. <br><br>Deseja revogar a concessão dos dados ao WISPOT?'                
      };

      let options = {
          html:true,
          okText: 'Sim',
          cancelText: 'Não',
      }


      // Trigger a confirmation dialog
      this.$dialog
      .confirm(message, options)
      .then(async function(dialog) {
          await instance.ActionRevokeWispot();                       
          instance.$toast.success("Sua conta foi excluida", {
            timeout: 10000
          });      

          instance.$router.push({name: 'revoked'});                                        
      })
      .catch(function(e) {
        console.log(e);
      });


    },
    ...mapActions('profile', ['ActionProfileSetData', 'ActionProfileGetData','ActionRevokeWispot']),
    ...mapActions('auth', ['ActionSignOut'])              
  },
  computed:{
    ...mapState('profile', ['profile'])
  }
}
</script>